import { Base, Component, Inject } from '@/vue-property-decorator'
import { ExhibitFallbackBg } from './exhibitFallbackBg'
import { GameCardCommonProps } from '../../common.type'
import { createSvgSprite } from '@/utils/business-utils/assets'
import style from './style.module.scss'
/** 兜底背景 注意:有使用absolute定位,因此,父级组件必须要有relative才行. */
@Component<FallbackBackground>({
  name: 'FallbackBackground'
})
export default class FallbackBackground extends Base {
  /** 是否显示背景图控制类 */
  public static ExhibitFallbackBg = ExhibitFallbackBg

  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>

  render() {
    const { inCardShape } = this.cardProps

    return (
      <icon-sprite
        class={{
          ['fallback-background']: true,
          [style['fallback-background']]: true,
          [style[`type-${inCardShape}-default`]]: true
        }}
        sprite={createSvgSprite('img_mryx_card')}
      />
    )
  }
}
